import { Flex, Typography, Dropdown, Button, Tooltip } from "antd";
import "./Details.scss";
import {
    DownloadOutlined,
    FilePdfOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { detailedViewDownloadPageHandle } from "../../helpers/helpers";
const { Text } = Typography;

const DetailsHeader = ({
    title,
    titleStyle = "",
    name,
    status,
    type,
    id,
}) => {
    const { loading } = useSelector(
        (state) => state.documents
    );
    const dispatch = useDispatch();

    const handleDownload = () => detailedViewDownloadPageHandle({ dispatch, type, id });

    const downloadItems = [
        {
            key: "pdf",
            label: "Download as PDF",
            icon: <FilePdfOutlined />,
        },
        // {
        //     key: "excel",
        //     label: "Download as Excel",
        //     icon: <FileExcelOutlined />,
        // },
    ];

    return (
        <Flex align="center" justify="space-between" className="details-header-container">
            <Text className={`title ${titleStyle}`}>{title}</Text>

            <Flex align="center" gap={12}>
                {name && <Text className="name">{`Viewing Details for ${name}`}</Text>}
                {status && status}

                <Dropdown
                    menu={{ items: downloadItems, onClick: handleDownload }}
                    placement="bottomRight"
                >
                    <Tooltip title="Download">
                        <Button
                            type="primary"
                            shape="circle"
                            icon={<DownloadOutlined />}
                            loading={loading}
                        />
                    </Tooltip>
                </Dropdown>
            </Flex>
        </Flex>
    );
};

export default DetailsHeader;
